import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Card, CardHeader } from 'shared/mui/Card';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '368px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  height: '80px',
  padding: '16px',
}));

export const OrderProviderExternalErrorsRatioChartTotalStyled = styled(Box)(({ theme }) => ({
  height: '60px',
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const OrderProviderExternalErrorsRatioChartScrollBox = styled(Box)(({ theme }) => ({
  height: '341px',
  overflow: 'auto',
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const OrderProviderExternalErrorsRatioChartHintBox = styled(Box)({
  height: '48px',
  padding: '16px',
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});

export const OrderProviderExternalErrorsRatioChartBarTitle = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '2px',
});

export const StyledLinearProgress = styled(LinearProgress)({
  height: '8px',
  backgroundColor: grey[300],
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#EF5350',
  },
});
